<template>
    <section>
        <div class="content">
            <div class="card card-default">
                <div class="card-header">
                    <h3 class="card-title">
                        <span>
                            <strong><i class="fa-solid fa-magnifying-glass"></i> {{ $t('labels.search') }}</strong>
                        </span>
                    </h3>
                    <div class="card-tools">

                    </div>
                </div>
                <!-- SEARCH CONTENT INPUT-->
                <div class="card-body">
                    <div class="row mb-2 row-cols-1 row-cols-sm-1 row-cols-md-4 row-cols-lg-4 row-cols-xl-4">
                        <div class="col mb-3">
                            <TheSelect id="" title="Số dòng" :options="pageOptions" :initialValue="pageSize.toString()"
                                @onChange="(v) => onChangePageOptions(v)" />
                        </div>
                        <div class="col mb-3">
                            <div class="col mb-3">
                                <TheInputText title="Tên" placeholder="Tìm theo tên" v-model="modelSearch.ten"
                                    :isRequire=false @onChange="v => handlePageChange(1)" />
                            </div>
                        </div>
                        <div class="col mb-3">
                            <TheDateRangePicker title="Ngày báo cáo" placeholder="Tìm theo ngày báo cáo"
                                v-model:startDate="modelSearch.ngayBaocaoTungay"
                                v-model:endDate="modelSearch.ngayBaocaoDenngay" :error="''" :isReadOnly="false"
                                :isRequire="false" :key="tempKey"
                                @onChange="(d) => onSelectSearchChange(d, 'NGAYBAOCAO')" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Hiển thị trên cổng" :options="category_ENABLED"
                                :initialValue="modelSearch.enabled" :isMultiple="false" :isAllowClear="true"
                                :isRequire="false" @onChange="(v) => onSelectSearchChange(v, 'ENABLED')" />
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </section>

    <section>
        <div class="content">
            <div class="card card-primary card-outline">
                <div class="card-header">
                    <h3 class="card-title">
                        <i class="fas fa-tag"></i>&nbsp;
                        <b v-if="sType_List == typeDataList.CURRENT_LIST.id">{{ $t('labels.currentList') }}</b>
                        <b v-if="sType_List == typeDataList.DELETED_LIST.id">{{ $t('labels.deletedList') }}</b>
                    </h3>
                    <div class="card-tools">
                        <button v-if="sType_List == typeDataList.DELETED_LIST.id" type="button" class="btn btn-tool"
                            :title="$t('buttons.swapCurrentList')" @click="changeCurrentTypeSearch()">
                            <i class="far fa-list-alt" style="color: #28a745;"></i>
                        </button>

                        <button v-if="sType_List == typeDataList.CURRENT_LIST.id" type="button" class="btn btn-tool"
                            :title="$t('buttons.swapDeletedList')" @click="changeCurrentTypeSearch()">
                            <i class="fas fa-list-alt" style="color: #df132e;"></i>
                        </button>
                        <button type="button" class="btn btn-tool" data-toggle="dropdown"
                            v-bind:title="$t('labels.cogs')">
                            <i class="fas fa-cogs"></i>
                            <div class="input-group-prepend">
                                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                                    <a v-if="sType_List == typeDataList.DELETED_LIST.id"
                                        class="dropdown-item text-green" href="#"
                                        @click="confirmList(navigateCode.RESTORE)" :title="$t('buttons.restore')"><i
                                            class="fas fa-undo"></i>&nbsp;&nbsp;{{ $t('buttons.restore') }}</a>
                                    <div class="dropdown-divider"></div>
                                    <a v-if="sType_List == typeDataList.CURRENT_LIST.id" class="dropdown-item text-red"
                                        href="#" @click="confirmList(navigateCode.DELETE_TEMP)"
                                        :title="$t('buttons.delete')"><i
                                            class="fas fa-trash-restore-alt"></i>&nbsp;&nbsp;{{ $t('buttons.delete')
                                        }}</a>
                                    <a v-if="sType_List == typeDataList.DELETED_LIST.id" class="dropdown-item text-red"
                                        href="#" @click="confirmList(navigateCode.DELETE)"
                                        :title="$t('buttons.deleteReal')"><i
                                            class="fas fa-trash-restore-alt"></i>&nbsp;&nbsp;{{ $t('buttons.deleteReal')
                                        }}</a>
                                    <div class="dropdown-divider"></div>
                                    <a v-if="sType_List == typeDataList.CURRENT_LIST.id"
                                        class="dropdown-item text-green" href="#"
                                        @click="confirmList(navigateCode.ON_ENABLED)"
                                        :title="$t('buttons.onEnabled')"><i class="fas fa-toggle-on"></i>&nbsp;&nbsp;
                                        {{ $t('buttons.onEnabled') }}</a>
                                    <a v-if="sType_List == typeDataList.CURRENT_LIST.id" class="dropdown-item text-red"
                                        href="#" @click="confirmList(navigateCode.OFF_ENABLED)"
                                        :title="$t('buttons.offEnabled')"><i class="fas fa-toggle-off"></i>&nbsp;&nbsp;
                                        {{ $t('buttons.offEnabled') }}</a>
                                    <div class="dropdown-divider"></div>
                                </div>
                            </div>
                        </button>
                        <button type="button" class="btn btn-tool" @click="detail(null, navigateCode.CREATE)"
                            v-bind:title="$t('buttons.create')">
                            <i class="fas fa-plus"></i>
                        </button>
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive p-0">
                        <loading :active="isBusy" class="text-center" color="#000000" loader="spinner"></loading>

                        <table class="table table-hover" id="table">
                            <thead>
                                <tr>
                                    <th class="col10"></th>
                                    <th class="col10">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input" type="checkbox" id="checkboxAll"
                                                @click="selectAllRows($event)">
                                            <label for="checkboxAll" class="custom-control-label"></label>
                                        </div>
                                    </th>
                                    <th class="col10 cursor" @click="handleSortChange('baocaoKehoachvonId')">
                                        ID
                                        <span v-if="sortBy == 'baocaoKehoachvonId'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col200 cursor" @click="handleSortChange('ten')">
                                        Tên
                                        <span v-if="sortBy == 'ten'" aria-hidden="true" class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col100">Ngày báo cáo</th>
                                    <th class="col100">Ghi chú</th>
                                    <th class="col10 cursor" @click="handleSortChange('stt')">
                                        STT
                                        <span v-if="sortBy == 'stt'" aria-hidden="true" class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col50">Hiển thị trên cổng</th>
                                    <!-- <th class="col50">Đồng bộ từ IOC tỉnh</th> -->
                                    <th class="col50"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in items" :key="item._id">
                                    <td></td>
                                    <td @click="selectRow(item.baocaoKehoachvonId)" style="cursor: pointer;"
                                        :title="$t('labels.selectItem')">
                                        <span v-if="(csList_Navigate.csList.includes(item.baocaoKehoachvonId))"
                                            aria-hidden="true" class="text-primary">&check;</span>
                                        <span v-else aria-hidden="true">&nbsp;</span>
                                    </td>
                                    <td>{{ item.baocaoKehoachvonId }}</td>
                                    <td>{{ item.ten }}</td>
                                    <td>{{ item.ngayBaocao }}</td>
                                    <td>{{ item.ghiChu }}</td>
                                    <td>{{ item.stt }}</td>
                                    <td>
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input"
                                                :disabled="sType_List == typeDataList.DELETED_LIST.id"
                                                :id="'item' + item.baocaoKehoachvonId" v-model="item.enabledDisplay"
                                                v-on:click="openConfirmEnabledChange(item)">
                                            <label class="custom-control-label"
                                                :for="'item' + item.baocaoKehoachvonId"></label>
                                        </div>
                                    </td>
                                    <td>
                                        <button type="button" size="sm" class="btn btn-outline-primary btn-xs"
                                            v-on:click="detail(item, navigateCode.DETAIL)" :title="$t('labels.detail')">
                                            <i class="fas fa-eye text-secondary"></i>
                                        </button>&nbsp;
                                        <span v-if="sType_List == typeDataList.CURRENT_LIST.id">
                                            <button type="button" size="sm" class="btn btn-outline-primary btn-xs"
                                                v-on:click="detail(item, navigateCode.UPDATE)"
                                                :title="$t('labels.update')">
                                                <i class="fas fa-pencil-alt"></i>
                                            </button>&nbsp;
                                        </span>
                                        <button type="button" size="sm" class="btn btn-outline-danger btn-xs"
                                            v-on:click="detail(item, sType_List == typeDataList.DELETED_LIST.id ? navigateCode.DELETE : navigateCode.DELETE_TEMP)"
                                            :title="$t('labels.delete')">
                                            <i class="fas fa-trash-alt"></i>
                                        </button>&nbsp;

                                        <button v-if="sType_List == typeDataList.DELETED_LIST.id" type="button"
                                            size="sm" class="btn btn-outline-warning btn-xs"
                                            v-on:click="detail(item, navigateCode.RESTORE)"
                                            :title="$t('labels.restore')">
                                            <i class="fas fa-undo"></i>
                                        </button>&nbsp;
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>

                <div class="card-footer clearfix">
                    <div class="row">
                        <div class="col-md-6">
                            <div v-if="totalRow != 0">Hiển thị {{ numberOfShow }} trên tổng số {{ totalRow }} dòng
                            </div>
                            <div v-else>Không có dữ liệu</div>
                        </div>
                        <div class="col-md-6">
                            <div class="float-right">
                                <ul class="pagination pagination-rounded">
                                    <paginate :page-count="pageCount" v-model="pageNumber" :page-range="3"
                                        :margin-pages="2" style="cursor: pointer;" :click-handler="handlePageChange"
                                        :prev-text="'Trở lại'" :next-text="'Kế đến'" :container-class="'pagination'"
                                        :page-class="'page-item'">
                                    </paginate>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <div class="modal fade" id="insUpdModal" data-keyboard="false" data-backdrop="static">
        <div class="modal-dialog modal-80vw">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title text-primary">{{ title }}</h4>
                    <button type="button" class="close" aria-label="Close" @click="hideModal()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-3">
                            <TheInputText title="Tên báo cáo kế hoạch vốn" placeholder="Nhập tên báo cáo kế hoạch vốn"
                                :initialValue="model.ten" v-model="model.ten" :error="errors.ten"
                                :isReadOnly="isReadOnly" :isRequire=true :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col-md-3">
                            <TheDatePicker title="Ngày báo cáo" placeholder="Chọn ngày báo cáo"
                                :initialValue="model.ngayBaocao" v-model="model.ngayBaocao" :error="errors.ngayBaocao"
                                :isReadOnly="isReadOnly" :isRequire="true" :key="tempKey"
                                @onChangeDate="(d) => onChangeNgayBaoCao(d)" />
                        </div>
                        <div class="col-md-3">
                            <TheInputText title="STT" placeholder="Nhập STT" :initialValue="model.stt"
                                v-model="model.stt" :error="errors.stt" :isReadOnly="isReadOnly" :isRequire=true
                                :isMultipleLine="false" :key="tempKey" />
                        </div>
                        <div class="col-md-3">
                            <div class="row">
                                <div class="col-md-12">
                                    <label>Hiển thị trên cổng</label>
                                </div>
                                <div class="col-md-12">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" id="enabled-checkbox"
                                            :disabled="isReadOnly" v-model="model.enabledDisplay">
                                        <label class="custom-control-label" for="enabled-checkbox"></label>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <TheInputText title="Ghi chú" placeholder="Nhập ghi chú" :initialValue="model.ghiChu"
                                v-model="model.ghiChu" :error="errors.ghiChu" :isReadOnly="isReadOnly" :isRequire=false
                                :isMultipleLine="true" :key="tempKey" />
                        </div>
                    </div>
                    <div class="row">
                        <div id="baocao-upsert"></div>
                    </div>

                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-outline-dark pull-left" @click="hideModal()">&nbsp;{{
                        $t('buttons.close') }} </button>

                    <button type="button" class="pull-right" :class="styleButton" @click="onSubmit();">&nbsp;{{
                        titleButton
                        }}</button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="detailModal" data-keyboard="false" data-backdrop="static">
        <div class="modal-dialog modal-80vw">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title text-success">{{ $t('labels.itemDetails') }} </h4>


                    <button type="button" class="close" aria-label="Close" @click="hidePopupDetail">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row" v-if="modelRec">
                        <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                            <div class="row">
                                <div class="col-md-2">
                                    <p class="text-sm">ID:
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.baocaoKehoachvonId }}&nbsp;</b>
                                    </p>
                                </div>
                                <div class="col-md-6">
                                    <p class="text-sm">Tên:
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.ten }}&nbsp;</b>
                                    </p>
                                </div>

                                <div class="col-md-2">
                                    <p class="text-sm">Ngày báo cáo:
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.ngayBaocao }}&nbsp;</b>
                                    </p>
                                </div>
                                <div class="col-md-2">
                                    <p class="text-sm">STT:
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.stt }}&nbsp;</b>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                            <p class="text-sm">Ghi chú:
                                <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.ghiChu }}&nbsp;</b>
                            </p>
                        </div>
                    </div>
                    <div class="row" v-if="modelBaoCao">
                        <div id="baocao-detail"></div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="modal fade" id="confirmcsListModal" data-keyboard="false" data-backdrop="static">
        <TheConfirmDialog :title="csList_MapModel.title" :confirmLabelButton="csList_MapModel.confirmLabelButton"
            :onClose="csList_MapModel.onClose" :onSubmit="csList_MapModel.onSubmit"
            :modalContent=csList_MapModel.modalContent></TheConfirmDialog>
    </div>

    <div class="modal fade" id="enabledConfirmModal" data-keyboard="false" data-backdrop="static">
        <TheCheckboxConfirmDialog :title="csListEnabled_MapModel.title"
            :confirmLabelButton="csListEnabled_MapModel.confirmLabelButton" :onClose="csListEnabled_MapModel.onClose"
            :onSubmit="csListEnabled_MapModel.onSubmit" :modalContent=csListEnabled_MapModel.modalContent
            v-model="checkEnable_Memo" :key="tempKey" :submitArgs="csListEnabled_MapModel.submitArgs">
        </TheCheckboxConfirmDialog>
    </div>
</template>
<script>

import $ from 'jquery'
import { mapActions } from 'vuex'
import config from '@/config/prod.env';
import objectDefaultValue from '@/config/object.env'
import Paginate from "vuejs-paginate-next";
import Loading from "vue3-loading-overlay";
import { common } from '@/helper/common';
import { read, utils, writeFileXLSX } from 'xlsx';
import { TabulatorFull as Tabulator } from 'tabulator-tables';
import TheInputText from '@/components/shareComponents/TheInputText.vue';
import TheSelect from '@/components/shareComponents/TheSelect.vue';
import TheConfirmDialog from '@/components/shareComponents/TheConfirmDialog.vue'
import TheCheckboxConfirmDialog from '@/components/shareComponents/TheCheckboxConfirmDialog.vue'
import TheDateRangePicker from '@/components/shareComponents/TheDateRangePicker.vue'
import TheDatePicker from '@/components/shareComponents/TheDatePicker.vue'

import { tableInteractiveModel } from '@/models/general/tableInteractive.model'
import { baocaoKehoachvonModel } from '@/models/taichinhkehoach/baocaoKehoachvon.model'
import { baocaoKehoachvonChitietModel } from '@/models/taichinhkehoach/baocaoKehoachvonChitiet.model'

export default {
    name: "BaoCaoKeHoachVon",
    components: {
        paginate: Paginate,
        loading: Loading,
        TheInputText,
        TheSelect,

        TheConfirmDialog,
        TheCheckboxConfirmDialog,
        TheDateRangePicker,
        TheDatePicker,
    },

    data() {
        return {
            header: '',
            isBusy: false,
            filter: null,
            items: [],

            pageNumber: config.CURRENT_PAGE,
            pageSize: config.DEFAULT_LIMIT,
            pageOptions: config.PAGE_OPTION,
            totalRow: 0,
            pageCount: 0,
            sortBy: null,
            orderDesc: true,
            numberOfShow: 0,
            title: null,
            titleButton: null,
            code: null,
            styleButton: null,
            styleTitle: null,
            isReadOnly: null,

            acceptImageType: objectDefaultValue.ACCEPT_TYPE_IMG,
            acceptTypeExcel: objectDefaultValue.ACCEPT_TYPE_EXCEL,

            modelRec: baocaoKehoachvonModel.newModel(),
            model: baocaoKehoachvonModel.newFEModel(),
            modelBaoCao: baocaoKehoachvonChitietModel.newModel(),
            errors: baocaoKehoachvonModel.errors(),
            modelSearch: baocaoKehoachvonModel.newPagingSearchModel(),

            cEnable_Value: null,

            navigateCode: objectDefaultValue.NAVIGATECODE_VALUE,
            navigateList: objectDefaultValue.NAVIGATECODE_LIST,
            typeDataList: objectDefaultValue.TYPEDATA_LIST,

            csList: [],
            csList_Code: null,
            checkEnable_Memo: false,
            sType_List: objectDefaultValue.TYPEDATA_LIST.CURRENT_LIST.id,

            csList_Navigate: tableInteractiveModel.newList_NavigateModel(),
            csList_MapModel: tableInteractiveModel.newListEnabled_MapModel(),

            csListEnabled_MapModel: tableInteractiveModel.newListEnabled_MapModel(),

            category_ENABLED: objectDefaultValue.ENABLED_SELECTION,

            tempKey: common.randomString(10),

            yearBaoCao: '',
            columns_baocao_detail: [
                { title: "STT", field: "sttBaocao", width: 80, headerSort: false, frozen: true, resizable: true },
                {
                    title: "Tên chủ đầu tư", field: "ten", width: 150, headerSort: false, frozen: true, resizable: true,
                    formatter: function (cell) {
                        var value = cell.getValue();
                        return "<div style='white-space: normal;'>" + value + "</div>";
                    }
                },
                {
                    title: "Tổng mức đầu tư từng công trình", field: "tongmucDautu", width: 80, headerSort: false, resizable: true,
                    formatter: function (cell) {
                        var value = cell.getValue();
                        return value ? new Intl.NumberFormat('vi-VN', {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 10,
                        }).format(value) : value;
                    }
                },
                {
                    title: "Vốn đầu tư công năm " + (this.yearBaoCao),
                    columns: [
                        {
                            title: "Năm trước chuyển sang năm", field: "vonNamtruocChuyensang", hozAlign: "center", width: 80, headerSort: false, resizable: true,
                            formatter: function (cell) {
                                var value = cell.getValue();
                                return value ? new Intl.NumberFormat('vi-VN', {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 10,
                                }).format(value) : value;
                            }
                        },
                        {
                            title: "Vốn phân khai trong năm 2024", field: "vonphankhaiTrongnam", hozAlign: "center", width: 80, headerSort: false, resizable: true,
                            formatter: function (cell) {
                                var value = cell.getValue();
                                return value ? new Intl.NumberFormat('vi-VN', {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 10,
                                }).format(value) : value;
                            }

                        },
                    ],
                },
                {
                    title: "Tình hình triển khai thực hiện", field: "tinhhinhTrienkhai", width: 400, headerSort: false, resizable: true,
                    formatter: function (cell) {
                        var value = cell.getValue();
                        return "<div style='white-space: normal;'>" + value + "</div>";
                    }
                },
                {
                    title: "Giải ngân đến thời điểm báo cáo ", field: "giaiNgan", width: 80, headerSort: false, resizable: true,
                    formatter: function (cell) {
                        var value = cell.getValue();
                        return value ? new Intl.NumberFormat('vi-VN', {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 10,
                        }).format(value) : value;
                    }
                },
                {
                    title: "Ước lũy kế vốn thanh toán từ đầu năm đến hết tháng báo cáo", field: "uocLuyke", width: 80, headerSort: false, resizable: true,
                    formatter: function (cell) {
                        var value = cell.getValue();
                        return value ? new Intl.NumberFormat('vi-VN', {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 10,
                        }).format(value) : value;
                    }
                },
                {
                    title: "Ước giải ngân cả năm 2024",
                    columns: [
                        {
                            title: "Năm trước chuyển sang năm 2024", field: "uocnamtruocChuyensang", hozAlign: "center", width: 80, headerSort: false, resizable: true,
                            formatter: function (cell) {
                                var value = cell.getValue();
                                return value ? new Intl.NumberFormat('vi-VN', {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 10,
                                }).format(value) : value;
                            }
                        },
                        {
                            title: "Vốn phân khai trong năm 2024", field: "uocTrongnam", hozAlign: "center", width: 80, headerSort: false, resizable: true,
                            formatter: function (cell) {
                                var value = cell.getValue();
                                return value ? new Intl.NumberFormat('vi-VN', {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 10,
                                }).format(value) : value;
                            }
                        },
                    ],
                },
                {
                    title: "Ghi chú", field: "ghiChu", width: 300, headerSort: false, resizable: true,
                    formatter: function (cell) {
                        var value = cell.getValue();
                        return "<div style='white-space: normal;'>" + value + "</div>";
                    }
                },

            ],
        }
    },

    methods: {
        ...mapActions('header', ['setupHeader',]),
        ...mapActions('alert', ['warning',]),
        ...mapActions('validate', ['validateRequired', 'validateNumber'],),
        ...mapActions('handleData2', ['handleChangeType',]),
        ...mapActions('baocaoKehoachvon', ['getPagingBaocaoKehoachvon', 'getDetailBaocaoKehoachvon', 'checkExistBaocaoKehoachvon', 'createBaocaoKehoachvon', 'updateBaocaoKehoachvon', 'deleteBaocaoKehoachvon', 'restoreBaocaoKehoachvon', 'handleListBaocaoKehoachvon', 'setEnabledBaocaoKehoachvon', 'getsBaocaoKehoachvonChiTietDaChot', 'getsBaocaoKehoachvonChiTietHienHanh']),

        async setup() {
            let header = 'Danh mục báo cáo kế hoạch vốn'
            this.setupHeader({ header })
        },

        async initialize() {

        },

        //#region NavigateModal
        async showModal() {
            $('#insUpdModal').modal('show')
        },
        async hideModal() {
            $('#insUpdModal').modal('hide')
            // await this.getData()
        },
        async showPopupDetail() {
            $('#detailModal').modal('show')
        },
        async hidePopupDetail() {
            $('#detailModal').modal('hide')
        },
        async showPopupconfirmcsListModal() {
            $('#confirmcsListModal').modal('show')
        },
        async hidePopupconfirmcsListModal() {
            $('#confirmcsListModal').modal('hide')
        },

        async showEnabledConfirmModal() {
            this.csListEnabled_MapModel = {
                title: "XÁC NHẬN",
                confirmLabelButton: "Xác nhận",
                onClose: this.closeConfirmEnabledChange,
                onSubmit: this.updateEnabled,
                submitArgs: [2],
                modalContent: "<label>Bạn có chắc chắn muốn thay đổi hiển thị trên cổng?</label>",
            }
            this.tempKey = common.randomString(10)
            $('#enabledConfirmModal').modal('show')
        },
        async hideEnabledConfirmModal() {
            $('#enabledConfirmModal').modal('hide')
        },
        //#endregion NavigateModal

        //#region NavigateInTable
        async openConfirmEnabledChange(item) {
            if (!this.checkEnable_Memo) {
                this.cEnable_Value = item
                await this.showEnabledConfirmModal()
            }
            else {
                this.cEnable_Value = item
                this.updateEnabled(1)

            }
        },

        async updateEnabled(from) {
            let model = {
                baocaoKehoachvonId: this.cEnable_Value.baocaoKehoachvonId,
                enabled: from == 1 ? !this.cEnable_Value.enabledDisplay : this.cEnable_Value.enabledDisplay
            }
            await this.setEnabledBaocaoKehoachvon({ model: model }).then(resp => {
                if (resp) {
                    this.hideEnabledConfirmModal()
                }
                else {
                    this.hideEnabledConfirmModal()
                }
            });
        },

        async closeConfirmEnabledChange() {
            this.cEnable_Value.enabledDisplay = !this.cEnable_Value.enabledDisplay
            $('#item' + this.cEnable_Value.baocaoKehoachvonId).prop('checked', this.cEnable_Value.enabledDisplay);
            await this.hideEnabledConfirmModal()
        },

        async navigateCheckBoxAll() {
            if (this.items.length != 0 && this.items.length == this.csList_Navigate.csList.length) {
                document.getElementById("checkboxAll").checked = true;
            }
            else {
                document.getElementById("checkboxAll").checked = false;
            }
        },

        async selectRow(id) {
            if (this.csList_Navigate.csList.includes(id)) {
                this.csList_Navigate.csList.splice(this.csList_Navigate.csList.indexOf(id), 1)
            }
            else {
                this.csList_Navigate.csList.push(id)
            }
            await this.navigateCheckBoxAll()
        },
        async selectAllRows(e) {
            if (e.target.checked) {
                this.csList_Navigate.csList = this.items.map((item) => {
                    return item.baocaoKehoachvonId
                })
            }
            else {
                this.csList_Navigate.csList = []
            }
        },
        //#endregion NavigateInTable

        //#region NavigateSearch
        async handleSortChange(sortCol) {
            if (this.sortBy == sortCol) {
                if (this.orderDesc == true) {
                    this.sortBy = sortCol
                    this.orderDesc = false
                    this.modelSearch.sort = sortCol + (this.orderDesc == true ? " desc" : " asc")
                }
                else if (this.orderDesc == false) {
                    this.orderDesc = null
                    this.sortBy = null
                    this.modelSearch.sort = null
                }
            }
            else {
                this.sortBy = sortCol
                this.orderDesc = true
                this.modelSearch.sort = sortCol + (this.orderDesc == true ? " desc" : " asc")
            }
            await this.getData()
        },
        async handlePageChange(page) {
            this.pageNumber = page
            await this.getData()
            await this.navigateCheckBoxAll()
        },
        async onChangePageOptions(pageSize) {
            this.pageSize = pageSize
            await this.handlePageChange(1)
        },

        async changeCurrentTypeSearch() {
            if (this.sType_List == this.typeDataList.DELETED_LIST.id) this.sType_List = this.typeDataList.CURRENT_LIST.id
            else if (this.sType_List == this.typeDataList.CURRENT_LIST.id) this.sType_List = this.typeDataList.DELETED_LIST.id
            await this.handlePageChange(1)
        },
        async onSelectSearchChange(e, typeChange) {
            if (typeChange == 'ENABLED') {
                switch (e) {
                    case "true":
                        this.modelSearch.enabled = true
                        break
                    case "false":
                        this.modelSearch.enabled = false
                        break
                    default:
                        this.modelSearch.enabled = null
                }
                this.handlePageChange(1)
                return
            }

            if (typeChange === 'NGAYBAOCAO') {
                await this.handlePageChange(1);
            }
        },
        async standardizationFilter() {
            this.modelSearch.pageNumber = this.pageNumber
            this.modelSearch.pageSize = this.pageSize
            if (this.modelSearch.ten == "") this.modelSearch.ten = null
            this.modelSearch.enabled = await this.handleChangeType({ input: this.modelSearch.enabled, typeChange: objectDefaultValue.changeTypeData.STRING_TO_BOOLEAN })
            // if (this.modelSearch.ngayBaocao == "") this.modelSearch.ngayBaocao = null
        },

        async getData() {
            this.isBusy = true
            this.csList_Navigate.csList = []
            await this.standardizationFilter()

            await this.getPagingBaocaoKehoachvon({ params: this.modelSearch, type: this.sType_List }).then(res => {
                // List data
                this.items = res.data
                if (this.items) {
                    for (let i = 0; i < this.items.length; i++) {
                        this.items[i].enabledDisplay = this.items[i].enabled == 1 ? true : false
                    }
                }

                // // Total row
                this.totalRow = res.totalRow
                // // Number show
                this.numberOfShow = !this.items ? 0 : ((this.pageNumber - 1) * this.pageSize) + this.items.length;
                // // Total number page
                this.pageCount = parseInt(((this.totalRow - 1) / this.pageSize)) + 1;
            });
            this.isBusy = false;
        },

        //#endregion NavigateSearch

        //#region CUD
        async detail(item, code) {
            this.code = code
            this.title = this.$t('labels.' + code)
            this.titleButton = this.$t('labels.' + code)
            this.styleButton = this.$t('style.styleButton' + code)
            this.styleTitle = this.$t('style.styleTitle' + code)
            this.errors = baocaoKehoachvonModel.errors()

            if (this.code == this.navigateCode.UPDATE || this.code == this.navigateCode.DELETE || this.code == this.navigateCode.RESTORE || this.code == this.navigateCode.DELETE_TEMP) {
                let params = {
                    baocaoKehoachvonId: item.baocaoKehoachvonId
                }
                let resp = await this.getDetailBaocaoKehoachvon({ params }).then(async resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        this.modelRec = baocaoKehoachvonModel.newModel()
                        this.modelRec = resp
                        this.model = baocaoKehoachvonModel.parseModeltoFEModel(this.modelRec)
                    }
                });

                await this.getsBaocaoKehoachvonChiTietDaChot({ params }).then(async res2 => {
                    this.modelBaoCao = baocaoKehoachvonChitietModel.newModel()
                    if (res2 == null) {
                        return
                    }
                    else {
                        this.modelBaoCao = res2

                        this.tabulator = new Tabulator("#baocao-upsert", {
                            columnHeaderVertAlign: "middle", //align header contents to bottom of cell
                            columns: await this.columnTabulatorDataSetup(this.modelRec.ngayBaocao),
                            data: this.modelBaoCao,
                            //responsiveLayout: true,
                            //resizableColumnFit:true
                            // resizableRows: true,
                            //resizableRowGuide: true,
                            height: "400px",
                            // // width: "400px",
                            layout: "fitData",
                            // responsiveLayout: true,
                            rowFormatter: function (row) {
                                var data = row.getData(); // Lấy dữ liệu của dòng
                                if (data.boldTen === 1) { // Điều kiện từ field "status"
                                    row.getElement().style.fontWeight = "bold"; // Tô đậm
                                    // row.getElement().style.backgroundColor = "#d1f7c4"; // Màu nền xanh
                                }
                            }

                        });
                    }
                });
                this.isReadOnly = (this.code == this.navigateCode.DELETE || this.code == this.navigateCode.RESTORE || this.code == this.navigateCode.DELETE_TEMP) ? true : false
                this.tempKey = common.randomString(10)
                await this.showModal()

            }
            else if (this.code == this.navigateCode.DETAIL) {
                let params = {
                    baocaoKehoachvonId: item.baocaoKehoachvonId
                }
                await this.getDetailBaocaoKehoachvon({ params }).then(resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        this.modelRec = baocaoKehoachvonModel.newModel()
                        this.modelRec = resp
                    }
                });

                await this.getsBaocaoKehoachvonChiTietDaChot({ params }).then(async res2 => {
                    this.modelBaoCao = baocaoKehoachvonChitietModel.newModel()
                    if (res2 == null) {
                        return
                    }
                    else {
                        this.modelBaoCao = res2

                        this.tabulator = new Tabulator("#baocao-detail", {
                            columnHeaderVertAlign: "middle", //align header contents to bottom of cell
                            columns: await this.columnTabulatorDataSetup(this.modelRec.ngayBaocao),
                            data: this.modelBaoCao,
                            //responsiveLayout: true,
                            //resizableColumnFit:true
                            // resizableRows: true,
                            //resizableRowGuide: true,
                            height: "400px",
                            // // width: "400px",
                            layout: "fitData",
                            // responsiveLayout: true,
                            rowFormatter: function (row) {
                                var data = row.getData(); // Lấy dữ liệu của dòng
                                if (data.boldTen === 1) { // Điều kiện từ field "status"
                                    row.getElement().style.fontWeight = "bold"; // Tô đậm
                                    // row.getElement().style.backgroundColor = "#d1f7c4"; // Màu nền xanh
                                }
                            }

                        });
                    }
                });

                this.tempKey = common.randomString(10)
                this.showPopupDetail()
            }
            else {

                this.model = baocaoKehoachvonModel.newFEModel()
                this.isReadOnly = (code == this.navigateCode.CREATE) ? false : true
                this.model.enabledDisplay = true
                this.model.stt = "0"
                let params = {
                }
                await this.getsBaocaoKehoachvonChiTietHienHanh({ params }).then(async res2 => {
                    this.modelBaoCao = baocaoKehoachvonChitietModel.newModel()
                    if (res2 == null) {
                        return
                    }
                    else {
                        this.modelBaoCao = res2
                        this.tabulator = new Tabulator("#baocao-upsert", {
                            columnHeaderVertAlign: "middle", //align header contents to bottom of cell
                            columns:  await this.columnTabulatorDataSetup(null),
                            data: this.modelBaoCao,
                            //responsiveLayout: true,
                            //resizableColumnFit:true
                            // resizableRows: true,
                            //resizableRowGuide: true,
                            height: "400px",
                            // // width: "400px",
                            layout: "fitData",
                            // responsiveLayout: true,
                            rowFormatter: function (row) {
                                var data = row.getData(); // Lấy dữ liệu của dòng
                                if (data.boldTen === 1) { // Điều kiện từ field "status"
                                    row.getElement().style.fontWeight = "bold"; // Tô đậm
                                    // row.getElement().style.backgroundColor = "#d1f7c4"; // Màu nền xanh
                                }
                            }
                        });
                    }
                });
                this.title = `Chốt số liệu báo cáo`
                this.titleButton = `Thêm báo cáo`
                // show popup
                this.tempKey = common.randomString(10)
                this.showModal()
            }
        },

        async checkExistName(name) {
            let params = {
                ten: name
            }
            let res = await this.checkExistBaocaoKehoachvon({ params: params })
            return res.data

        },
        async validate(model) {
            let isvalid = true
            this.errors = baocaoKehoachvonModel.errors()
            if (!await this.validateRequired(model.ten)) {
                this.errors.ten = "Nhập tên"
                isvalid = false
            }
            else if (this.code == this.navigateCode.UPDATE && this.model.ten != model.ten) {
                if (await this.checkExistName(model.ten)) {
                    this.errors.ten = "Tên này đã tồn tại trên hệ thống"
                    isvalid = false
                }
            }
            else if (this.code == this.navigateCode.CREATE) {
                if (await this.checkExistName(model.ten)) {
                    this.errors.ten = "Tên này đã tồn tại trên hệ thống"
                    isvalid = false
                }
            }

            if (!await this.validateRequired(model.ngayBaocao)) {
                this.errors.ngayBaocao = "Chọn ngày báo cáo"
                isvalid = false
            }
            if (!await this.validateRequired(model.stt)) {
                this.errors.stt = "Nhập số thứ tự"
                isvalid = false
            }
            else if (!await this.validateNumber(model.stt)) {
                this.errors.stt = "Số thứ tự phải là kiểu số"
                isvalid = false
            }




            return isvalid
        },
        async modifySendModel(FEmodel) {
            let sendModel = baocaoKehoachvonModel.newModel()
            if (this.code == this.navigateCode.DELETE
                || this.code == this.navigateCode.RESTORE
                || this.code == this.navigateCode.DELETE_TEMP) sendModel.baocaoKehoachvonId = FEmodel.baocaoKehoachvonId
            else {
                if (this.code == this.navigateCode.UPDATE) sendModel.baocaoKehoachvonId = FEmodel.baocaoKehoachvonId
                console.log(FEmodel)
                sendModel.ten = FEmodel.ten
                sendModel.ngayBaocao = FEmodel.ngayBaocao
                sendModel.ghiChu = FEmodel.ghiChu
                sendModel.stt = FEmodel.stt
                sendModel.enabled = FEmodel.enabledDisplay ? FEmodel.enabledDisplay : false
                console.log(sendModel)
            }
            return sendModel
        },
        async onSubmit() {
            let code = this.code
            let sendModel = await this.modifySendModel(this.model)
            let res = false
            switch (code) {
                case this.navigateCode.CREATE:
                    if (await this.validate(sendModel)) {
                        res = await this.createBaocaoKehoachvon({ model: sendModel })
                    }
                    break
                case this.navigateCode.UPDATE:
                    if (await this.validate(sendModel)) {
                        res = await this.updateBaocaoKehoachvon({ model: sendModel })
                    }
                    break
                case this.navigateCode.DELETE_TEMP:
                    res = await this.deleteBaocaoKehoachvon({ model: sendModel, type: this.sType_List })
                    break
                case this.navigateCode.DELETE:
                    res = await this.deleteBaocaoKehoachvon({ model: sendModel, type: this.sType_List })
                    break
                case this.navigateCode.RESTORE:
                    res = await this.restoreBaocaoKehoachvon({ model: sendModel })
                    break
                default:
            }
            if (res) {
                await this.getData()
                this.hideModal()
            }
        },

        async columnTabulatorDataSetup(dateString) {
            let yearBaoCao = await this.getYearFromDateString(dateString)
            let columnsSet =
                [
                    { title: "STT", field: "sttBaocao", width: 80, headerSort: false, frozen: true, resizable: true },
                    {
                        title: "Tên chủ đầu tư", field: "ten", width: 150, headerSort: false, frozen: true, resizable: true,
                        formatter: function (cell) {
                            var value = cell.getValue();
                            return "<div style='white-space: normal;'>" + value + "</div>";
                        }
                    },
                    {
                        title: "Tổng mức đầu tư từng công trình", field: "tongmucDautu", width: 80, headerSort: false, resizable: true,
                        formatter: function (cell) {
                            var value = cell.getValue();
                            return value ? new Intl.NumberFormat('vi-VN', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 10,
                            }).format(value) : value;
                        }
                    },
                    {
                        title: "Vốn đầu tư công năm " + (yearBaoCao),
                        columns: [
                            {
                                title: "Năm trước chuyển sang năm", field: "vonNamtruocChuyensang", hozAlign: "center", width: 80, headerSort: false, resizable: true,
                                formatter: function (cell) {
                                    var value = cell.getValue();
                                    return value ? new Intl.NumberFormat('vi-VN', {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 10,
                                    }).format(value) : value;
                                }
                            },
                            {
                                title: "Vốn phân khai trong năm " + (yearBaoCao), field: "vonphankhaiTrongnam", hozAlign: "center", width: 80, headerSort: false, resizable: true,
                                formatter: function (cell) {
                                    var value = cell.getValue();
                                    return value ? new Intl.NumberFormat('vi-VN', {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 10,
                                    }).format(value) : value;
                                }

                            },
                        ],
                    },
                    {
                        title: "Tình hình triển khai thực hiện", field: "tinhhinhTrienkhai", width: 400, headerSort: false, resizable: true,
                        formatter: function (cell) {
                            var value = cell.getValue();
                            return "<div style='white-space: normal;'>" + value + "</div>";
                        }
                    },
                    {
                        title: "Giải ngân đến thời điểm báo cáo " + (dateString ? dateString : ''), field: "giaiNgan", width: 80, headerSort: false, resizable: true,
                        formatter: function (cell) {
                            var value = cell.getValue();
                            return value ? new Intl.NumberFormat('vi-VN', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 10,
                            }).format(value) : value;
                        }
                    },
                    {
                        title: "Ước lũy kế vốn thanh toán từ đầu năm đến hết tháng báo cáo", field: "uocLuyke", width: 80, headerSort: false, resizable: true,
                        formatter: function (cell) {
                            var value = cell.getValue();
                            return value ? new Intl.NumberFormat('vi-VN', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 10,
                            }).format(value) : value;
                        }
                    },
                    {
                        title: "Ước giải ngân cả năm " + (yearBaoCao),
                        columns: [
                            {
                                title: "Năm trước chuyển sang năm " + (yearBaoCao), field: "uocnamtruocChuyensang", hozAlign: "center", width: 80, headerSort: false, resizable: true,
                                formatter: function (cell) {
                                    var value = cell.getValue();
                                    return value ? new Intl.NumberFormat('vi-VN', {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 10,
                                    }).format(value) : value;
                                }
                            },
                            {
                                title: "Vốn phân khai trong năm " + (yearBaoCao), field: "uocTrongnam", hozAlign: "center", width: 80, headerSort: false, resizable: true,
                                formatter: function (cell) {
                                    var value = cell.getValue();
                                    return value ? new Intl.NumberFormat('vi-VN', {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 10,
                                    }).format(value) : value;
                                }
                            },
                        ],
                    },
                    {
                        title: "Ghi chú", field: "ghiChu", width: 300, headerSort: false, resizable: true,
                        formatter: function (cell) {
                            var value = cell.getValue();
                            return "<div style='white-space: normal;'>" + value + "</div>";
                        }
                    },

                ]
            return columnsSet
        },

        async getYearFromDateString(dateString) {
            if(!dateString){
                return ''
            }
            // Tách chuỗi dd/MM/yyyy
            var parts = dateString.split('/'); // ['dd', 'MM', 'yyyy']

            // Tạo đối tượng Date theo định dạng yyyy-MM-dd
            var date = new Date(parts[2], parts[1] - 1, parts[0]); // Tháng trong Date bắt đầu từ 0

            // Trả về năm
            return date.getFullYear();
        },
        async onChangeNgayBaoCao(d) {
            this.model.ngayBaocao = d
            let yearBaoCao = await this.getYearFromDateString(d)
            this.tabulator.setColumns(
                await this.columnTabulatorDataSetup(d)
            );

            // this.tabulator.redraw();
        },
        //#endregion CUD

        //#region NavigateMultipleInTable
        async confirmList(code) {
            if (this.csList_Navigate.csList.length == 0) {
                this.warning(this.$t('labels.selectItem'))
            }
            else {
                this.csList_Navigate.csList_Code = code
                let foundItem = this.navigateList.find(item => item.code === code);
                this.csList_Navigate.csList_Title = foundItem ? foundItem.title : ""

                this.csList_MapModel = {
                    title: this.csList_Navigate.csList_Title,
                    confirmLabelButton: this.csList_Navigate.csList_Title,
                    onClose: this.hidePopupconfirmcsListModal,
                    onSubmit: this.onSubmitList,
                    modalContent: "Bạn có chắc chắn <b>" + this.csList_Navigate.csList_Title + "</b> các dữ liệu đã chọn?",
                }
                this.showPopupconfirmcsListModal()
            }
        },
        async onSubmitList() {
            let code = this.csList_Navigate.csList_Code
            let modelSend = {
                model: {
                    listId: this.csList_Navigate.csList.toString()
                },
                type: code
            }
            if (code == this.navigateCode.OFF_ENABLED) {
                modelSend.model.enabled = false
            }
            if (code == this.navigateCode.ON_ENABLED) {
                modelSend.model.enabled = true
            }
            // if (code == this.navigateCode.ON_IOC_ENABLED) {
            //     modelSend.model.enabled = false
            // }
            // if (code == this.navigateCode.OFF_IOC_ENABLED) {
            //     modelSend.model.enabled = true
            // }
            let res = null
            res = await this.handleListBaocaoKehoachvon(modelSend)
            if (res) {
                await this.getData()
                await this.navigateCheckBoxAll()
                this.hidePopupconfirmcsListModal()
            }
        },
        //#endregion NavigateMultipleInTable

        //#region getCategory

        //#endregion getCategory
    },

    async mounted() {
        await this.initialize()
        await this.setup()
        await this.getData()
    }
}
</script>
<style>
.tabulator .tabulator-header .tabulator-col .tabulator-col-content .tabulator-col-title {
    white-space: normal !important;
    overflow-wrap: break-word !important;
    text-align: center !important;
}
</style>